import { FC, ReactNode } from 'react';

import { useSelection } from 'src/contexts/SelectionContext';

import { PreviewSessionContext } from './PreviewSessionContext';
import { usePreviewSessionManager } from './hooks/usePreviewSessionManager';

interface PreviewSessionProviderProps {
  children: ReactNode;
}

/**
 * Provider component for the Preview Session context.
 * Wraps the usePreviewSessionManager hook to provide centralized
 * session state management to all child components.
 *
 * @example
 * <PreviewSessionProvider>
 *   <App />
 * </PreviewSessionProvider>
 */
export const PreviewSessionProvider: FC<PreviewSessionProviderProps> = ({ children }) => {
  const { marketplace, deviceFamily, placement } = useSelection();
  const manager = usePreviewSessionManager({ marketplace, deviceFamily, placement });

  return (
    <PreviewSessionContext.Provider value={manager}>{children}</PreviewSessionContext.Provider>
  );
};
